import InputLabeled from "./input-labeled";
export default InputLabeled
